import { useEffect } from 'react';
import { DragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';


const elementSource = {
    beginDrag(props, monitor) {
        let elements = props.dragList(props.element);
        const initialPosition = monitor.getInitialClientOffset();
        props.setInitialClientOffset && props.setInitialClientOffset(initialPosition.y)
        return { elements };
    }
}

function collect(connect, monitor, props) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: props.noShallowCopy ? null : connect.dragPreview(),
        isDragging: monitor.isDragging(),
    }
}

const DragSourceElement = (props) => {
    let { element, elementIndex, seleccion, parentIndex, parentSeleccion, connectDragSource, connectDragPreview, className, key } = props

    useEffect(() => {
        if (connectDragPreview) connectDragPreview(getEmptyImage(), { captureDraggingState: true });
    }, [connectDragPreview]);


    let classNames = className;
    if ((!parentIndex && elementIndex === seleccion) || (parentIndex === parentSeleccion && elementIndex === seleccion)) {
        classNames += " selected";
    }
   
    return connectDragSource(
        <div className={classNames} key={key}>{element}</div>
    )
}

export default DragSource('element', elementSource, collect)(DragSourceElement);